<template>
  <van-popup
    v-model="localRackShow"
    position="bottom"
    :style="{ height: '90%' }"
    round
    closeable
    close-icon="cross"
    @click-close-icon="handleClose"
  >
    <!-- 顶部标题栏 -->
    <div class="popup-header">
      <van-icon name="bars" class="header-icon" />
      <span class="header-title">维护异常设备详情</span>
    </div>

    <!-- 内容区域 -->
    <div class="popup-body">
      <div v-for="(device, index) in detailList" :key="index" class="device-card">
        <!-- 设备标题行 -->
        <div class="device-header">
          <van-tag type="primary" plain class="device-tag">序号 {{ index + 1 }}</van-tag>
          <span class="device-number">设备编号：{{ device.device_number }}</span>
        </div>

        <!-- 近30天告警信息 -->
        <van-cell-group :border="false" class="info-group">
          <van-cell :border="false" class="warn-cell">
            <template #title>
              <span class="cell-label">近30天告警信息：</span>
              <span class="cell-value">{{ device.warn_info || "--" }}</span>
            </template>
          </van-cell>
        </van-cell-group>

        <!-- 工单号展示（纯文本，空值不展示） -->
        <van-cell-group :border="false" class="ticket-group">
          <van-cell
            v-if="device.ticket_id && device.ticket_id !== 'null'"
            :border="false"
            class="ticket-cell"
          >
            <template #title>
              <span class="cell-label">上次维护子单号：</span>
              <span class="ticket-text">{{ device.ticket_id }}</span>
            </template>
          </van-cell>
          <van-cell
            v-if="device.p_ticket_id && device.p_ticket_id !== 'null'"
            :border="false"
            class="ticket-cell"
          >
            <template #title>
              <span class="cell-label">问题跟进单号：</span>
              <span class="ticket-text">{{ device.p_ticket_id }}</span>
            </template>
          </van-cell>
          <van-cell
            v-if="device.event_id && device.event_id !== 'null'"
            :border="false"
            class="ticket-cell"
          >
            <template #title>
              <span class="cell-label">维修单号：</span>
              <span class="ticket-text">{{ device.event_id }}</span>
            </template>
          </van-cell>
        </van-cell-group>

        <!-- 检查项明细（折叠面板） -->
        <van-collapse v-model="activeCollapses[index]" class="check-collapse">
          <van-collapse-item title="检查项明细" name="1">
            <div
              v-for="(item, idx) in device.sub_check_list"
              :key="idx"
              class="check-item"
            >
              <div class="check-item-header">
                <van-tag round type="default" size="medium">{{ idx + 1 }}</van-tag>
                <span class="check-item-name">{{ item.check_item_name || "--" }}</span>
              </div>
              <div class="check-item-body">
                <div class="check-row">
                  <span class="check-label">检查项明细</span>
                  <span class="check-value">{{ item.check_item_content || "--" }}</span>
                </div>
                <div class="check-row">
                  <span class="check-label">异常部位</span>
                  <span class="check-value">{{ item.abnormal_area || "--" }}</span>
                </div>
                <div class="check-row">
                  <span class="check-label">异常描述</span>
                  <span class="check-value">{{
                    item.exception_description || "--"
                  }}</span>
                </div>
                <div class="check-row">
                  <span class="check-label">是否影响运行</span>
                  <span class="check-value">{{ item.running_status || "--" }}</span>
                </div>
                <div class="check-row">
                  <span class="check-label">原因分析</span>
                  <span class="check-value">{{ item.reason_analysis || "--" }}</span>
                </div>
              </div>
            </div>
            <van-empty
              v-if="!device.sub_check_list || device.sub_check_list.length === 0"
              description="暂无检查项数据"
              image="search"
            />
          </van-collapse-item>
        </van-collapse>
      </div>

      <!-- 空状态 -->
      <van-empty
        v-if="!detailList || detailList.length === 0"
        description="暂无设备数据"
      />
    </div>
  </van-popup>
</template>

<script>
export default {
  name: "maintainDetails",
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
    detailList: {
      type: Array,
      default: () => [],
      // default: () => [
      //   {
      //     device_number: "CQ-TH-BD2-CRA102-PMM-H",
      //     event_id: "null",
      //     p_ticket_id: "10260513004480",
      //     status: "确认中",
      //     sub_check_list: [
      //       {
      //         abnormal_area: "接线端子",
      //         audit_quality: "有效异常",
      //         check_item_content:
      //           "维护人员确认已通过维护变更审批，已通知现场数经、ECC值班岗、FOC监控岗等。",
      //         check_item_name: "设备编号核对",
      //         eg_remark: "",
      //         event_id: "null",
      //         exception_description: "温升异常",
      //         fmc_remark: "已处理",
      //         mcm_remark: "通过",
      //         p_ticket_id: "10260513004480",
      //         reason_analysis: "出现松动，已紧固",
      //         running_status: "轻微影响",
      //         status: "确认中",
      //         ticket_id: "10260513004474",
      //       },
      //       {
      //         abnormal_area: "接线端子",
      //         audit_quality: "有效异常",
      //         check_item_content:
      //           "1.检查SPM柜主要部件，如开关、熔丝、避雷器、互感器、铜排、接插件等外观完好，状态正常；\n2.检查SPM柜工作状态指示灯与实际运行状态相符。",
      //         check_item_name: "检查综合配电柜主要部件及指示灯",
      //         eg_remark: "",
      //         event_id: "null",
      //         exception_description: "温升异常",
      //         fmc_remark: "已处理",
      //         mcm_remark: "通过",
      //         p_ticket_id: "10260513004480",
      //         reason_analysis: "出现松动，已紧固",
      //         running_status: "轻微影响",
      //         status: "确认中",
      //         ticket_id: "10260513004474",
      //       },
      //     ],
      //     ticket_id: "10260513004474",
      //     warn_info: "无",
      //   },
      //   {
      //     device_number: "CQ-TH-BD2-CRA102-PMM-D",
      //     event_id: "null",
      //     p_ticket_id: "10260513005250",
      //     status: "已处理",
      //     sub_check_list: [
      //       {
      //         abnormal_area: "接地部位",
      //         audit_quality: "有效异常",
      //         check_item_content:
      //           "至设备所在区域，检查设备编号与授权实施维护对象编号一致，明确维护对象，穿戴必备的个人防护用品。",
      //         check_item_name: "设备编号核对",
      //         eg_remark: "12111",
      //         event_id: "null",
      //         exception_description: "温升异常",
      //         fmc_remark: "已处理",
      //         mcm_remark: "已确认处理",
      //         p_ticket_id: "10260513005250",
      //         reason_analysis: "1222211",
      //         running_status: "轻微影响",
      //         status: "已处理",
      //         ticket_id: "10260513004325",
      //       },
      //     ],
      //     ticket_id: "10260513004325",
      //     warn_info: "无",
      //   },
      // ],
    },
  },
  data() {
    return {
      localRackShow: this.isShow,
      activeCollapses: [],
      emitQuery: "向表单传递参数",
    };
  },
  watch: {
    isShow(newVal) {
      console.log("newVal =======", newVal);
      this.localRackShow = newVal;
    },
    localRackShow(newVal) {
      // 弹窗关闭时通知父组件将isShow设为false
      if (!newVal) {
        this.$emit("update:isShow", false);
        this.$emit("handleClose", this.emitQuery);
      }
    },
    detailList: {
      handler(list) {
        // 为每个设备初始化折叠面板状态
        this.activeCollapses = (list || []).map(() => []);
      },
      immediate: true,
    },
  },

  methods: {
    handleClose() {
      this.localRackShow = false;
    },
  },
};
</script>

<style lang="less" scoped>
/* 顶部标题栏 */
.popup-header {
  display: flex;
  align-items: center;
  padding: 16px;
  border-bottom: 1px solid #f0f0f0;
  position: sticky;
  top: 0;
  background: #fff;
  z-index: 10;

  .header-icon {
    font-size: 20px;
    color: #1989fa;
    margin-right: 8px;
  }

  .header-title {
    font-size: 16px;
    font-weight: 600;
    color: #323233;
  }
}

/* 内容区域 */
.popup-body {
  padding: 12px;
  overflow-y: auto;
  height: calc(100% - 56px);
  -webkit-overflow-scrolling: touch;
}

/* 设备卡片 */
.device-card {
  background: #fff;
  border-radius: 10px;
  padding: 12px;
  margin-bottom: 12px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
  border: 1px solid #f2f3f5;
}

/* 设备标题行 */
.device-header {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  gap: 8px;
  margin-bottom: 10px;
  overflow: hidden;

  .device-tag {
    flex-shrink: 0;
  }

  .device-number {
    font-size: 14px;
    font-weight: 600;
    color: #323233;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

/* 信息组 */
.info-group {
  margin-bottom: 4px;

  /deep/ .van-cell {
    padding: 4px 0;
  }
}

.warn-cell {
  /deep/ .van-cell__title {
    display: flex;
    align-items: flex-start;
    flex-wrap: wrap;
  }
}

.cell-label {
  font-size: 13px;
  font-weight: 600;
  color: #323233;
  white-space: nowrap;
}

.cell-value {
  font-size: 13px;
  color: #646566;
  word-break: break-all;
}

/* 工单号区域 */
.ticket-group {
  margin-bottom: 8px;

  /deep/ .van-cell {
    padding: 3px 0;
  }
}

.ticket-cell {
  /deep/ .van-cell__title {
    display: flex;
    align-items: center;
  }
}

.ticket-text {
  font-size: 13px;
  color: #1989fa;
  word-break: break-all;
}

/* 检查项折叠面板 */
.check-collapse {
  margin-top: 8px;

  /deep/ .van-collapse-item__title {
    font-size: 14px;
    font-weight: 600;
    color: #323233;
    padding: 10px 0;
  }

  /deep/ .van-collapse-item__content {
    padding: 0;
  }
}

/* 检查项条目 */
.check-item {
  background: #f7f8fa;
  border-radius: 8px;
  padding: 10px 12px;
  margin-bottom: 8px;

  &:last-child {
    margin-bottom: 0;
  }
}

.check-item-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;

  .check-item-name {
    font-size: 13px;
    font-weight: 600;
    color: #323233;
  }
}

.check-item-body {
  .check-row {
    display: flex;
    align-items: flex-start;
    padding: 4px 0;
    border-bottom: 1px dashed #ebedf0;

    &:last-child {
      border-bottom: none;
    }

    .check-label {
      font-size: 12px;
      color: #969799;
      min-width: 80px;
      flex-shrink: 0;
      line-height: 20px;
    }

    .check-value {
      font-size: 12px;
      color: #323233;
      line-height: 20px;
      word-break: break-all;
      white-space: pre-line;
    }
  }
}
</style>
